<template>
    <div>
        <info-radio v-for="(item, key) in data" :filter-id="filterId" :current-value="currentValue" :name="name" :value="item.value" :key="key" :child-filter="item.childFilter">
            <p>
                {{ $t(item.value)}}
            </p>
        </info-radio>
    </div>
</template>

<script>
    import InfoRadio from './RadioFilter'
    import { EventBus } from '../../services/eventBus'

    export default {
        created () {
            EventBus.$on('radio-button::new-value', function(value, name) {
                if (name == this.name) {
                    this.currentValue = value;
                }
            }.bind(this));

            EventBus.$on('filtersReset', function() {
                this.currentValue = ''
            }.bind(this))
        },
        name: "info-radios",
        props: {
            filterId: String,
            name: String,
            data: Array
        },
        components: {
            'info-radio': InfoRadio
        },
        data () {
            return {
                currentValue: '',
            }
        },
        mounted: function() {
          for (let x in this.data) {
            if (this.data[x].checked == 1) {
                this.currentValue = this.data[x].value
            }
          }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/RadiosFilter.vue